module.exports = __webpack_public_path__ + "static/media/TATAMOTORS_F1.ecd2c9af.txt";